"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
//Found this ObjectId generator here: https://stackoverflow.com/a/37438675
var _default = exports["default"] = function _default() {
  var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Math;
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date;
  var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (s) {
    return m.floor(s).toString(h);
  };
  return s(d.now() / 1000) + ' '.repeat(h).replace(/./g, function () {
    return s(m.random() * h);
  });
};